<template>
    <transition name="slide-fade">
        <component
        v-if="visible" 
        :is="sectionFile"
        :section="section" 
        :sections="sections" 
        :rows="rows" />
    </transition>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        props: {
            section: {
                type: Object,
                default: () => {}
            }
        },

        computed: {

            ...mapGetters('form', [
                'isVisible'
            ]),

            visible() {
                return this.isVisible(this.section)
            },

            ...mapState({
                form: state => state.form
            }),

            rows() {
                return _.filter(this.form.rows, row => {
                    return row.parentable_type == 'formSection' 
                    && row.parentable_id == this.section.id
                    && this.isVisible(row)
                })
            },

            sections() {
                return _.filter(this.form.sections, section => {
                    return section.parentable_type == 'formSection' 
                    && section.parentable_id == this.section.id
                    && this.isVisible(section)
                })
            },

            sectionFile() {

                var custom = false
                var form = this.form.form
                var key = form.theme ? form.theme : form.key

                // Is it exists in a custom context ?
                try {
                    require('@components/forms/'+key+'/Section');
                    return () => import(`@components/forms/${key}/Section.vue`)
                } catch (e) {}


                // Does the layout has a section file ?
                try {
                    require('@components/forms/layouts/'+form.layout+'/Section');
                    return () => import(`@components/forms/layouts/${form.layout}/Section.vue`)
                } catch (e) {}


                return () => import(`@components/forms/layouts/default/Section`)

            }

        },

        methods: {
        }

    }
</script>